// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1hkEP","imageUploader":"EGiftCard_imageUploader__cN0UB"};